module.exports = __webpack_public_path__ + "1e2d28dff5a35de699267da82e34cdb6.svg";